<div>
  <!-- Left Sidebar -->
  <aside
    automation-id="sidebar-aside-1"
    id="leftsidebar"
    class="sidebar"
    (mouseenter)="mouseHover()"
    (mouseleave)="mouseOut()"
    >
    <!-- Menu -->
    <div
      class="menu"
      style="position: relative; border-right: 1px solid #e5e7eb"
      >
      <ng-scrollbar
        automation-id="sidebar-ng-scrollbar-2"
        [style.height]="listMaxHeight + 'px'"
        visibility="hover"
        >
        <ul automation-id="sidebar-ul-3" class="list">
          <li
            automation-id="sidebar-li-4"
            class="sidebar-user-panel"
            style="border-bottom: 1px solid #e5e7eb; margin-bottom: 16px"
            >
            <!-- <div class="user-panel">
            <div class=" image">
              <img  automation-id="sidebar-img-5" src={{userImg}} class="img-circle user-img-circle" alt="User Image" />
            </div>
          </div> -->
          <div class="profile-usertitle">
            <div class="user-name-circle">
              {{ loggedInUser?.currentUser?.data?.firstName?.[0]
              }}{{ loggedInUser?.currentUser?.data?.lastName?.[0] }}
            </div>
            <div class="user-name page-header">
              <p automation-id="sidebar-p-6">
                {{ loggedInUser?.currentUser?.data?.firstName }}
                {{ loggedInUser?.currentUser?.data?.lastName }}
              </p>
            </div>
            <div>
              <div class="facility-name sidebar-miniText">
                <p automation-id="sidebar-p-7">
                  <span
                    >{{ loggedInUser?.facilityInfo?.data?.facilityName }}
                  </span>
                </p>
                <p automation-id="sidebar-p-7">
                  @if (
                    loggedInUser?.organizationInfo?.data?.organizationName
                    ) {
                    <span
                      >
                      {{
                      loggedInUser?.organizationInfo?.data?.organizationName
                      }}</span
                      >
                    }
                  </p>
                </div>
              </div>

              <div class="profile-usertitle-job sidebar-miniText-1">
                <p automation-id="sidebar-p-8">
                  {{
                  loggedInUser?.currentUser?.data?.userType.toLowerCase() !=
                  "admin"
                  ? loggedInUser?.currentUser?.data?.userType
                  : "Local Admin"
                  }}
                </p>
              </div>
            </div>
          </li>
          <!-- Top Most level menu -->
          @for (sidebarItem of sidebarItems; track sidebarItem) {
            <li
              automation-id="sidebar-li-9"
              [class.active-top]="isActive(sidebarItem.path)"
              #sidebarList
              >
              @if (sidebarItem.groupTitle === true) {
                <div class="header">
                  <p automation-id="sidebar-p-'sidebarItem.automationId'">
                    {{ sidebarItem.title | translate }}
                  </p>
                </div>
              }
              @if (!sidebarItem.groupTitle) {
                <a
                  [attr.automation-id]="'sidebar-a-' + sidebarItem.automationId"
              [routerLink]="
                sidebarItem.class === '' ? [sidebarItem.path] : null
              "
                  [ngClass]="[sidebarItem.class]"
              [ngClass]="
                (_glob.submitOrderProcess$ | async)
                  ? 'no-pointers'
                  : 'all-pointers'
              "
                  (click)="callToggleMenu($event, sidebarItem.submenu.length)"
                  class="menu-top"
                  >
                  <!-- <pre automation-id="sidebar-pre-12">{{sidebarItem.title|json}}</pre> -->
                  <!-- <i
                  [attr.automation-id]="'sidebar-i-' + sidebarItem.automationId"
                  [ngClass]="[sidebarItem.iconType]"
                [ngStyle]="
                  sidebarItem.icon === 'local_mall' ||
                  sidebarItem.icon === 'assignment_turned_in'
                    ? { 'font-size': '19px' }
                    : { 'font-size': '20px' }
                "
                  >{{ sidebarItem.icon }}</i
                  > -->
                  <div>
                    @switch (sidebarItem.path) {
                      <!-- Case 1 -->
                      @case ('/orders/history') {
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          >
                          <g clip-path="url(#clip0)">
                            <path
                              d="M10.8335 2.5C6.69183 2.5 3.3335 5.85833 3.3335 10H0.833496L4.07516 13.2417L4.1335 13.3583L7.50016 10H5.00016C5.00016 6.775 7.6085 4.16667 10.8335 4.16667C14.0585 4.16667 16.6668 6.775 16.6668 10C16.6668 13.225 14.0585 15.8333 10.8335 15.8333C9.22516 15.8333 7.76683 15.175 6.71683 14.1167L5.5335 15.3C6.89183 16.6583 8.7585 17.5 10.8335 17.5C14.9752 17.5 18.3335 14.1417 18.3335 10C18.3335 5.85833 14.9752 2.5 10.8335 2.5ZM10.0002 6.66667V10.8333L13.5668 12.95L14.1668 11.9417L11.2502 10.2083V6.66667H10.0002Z"
                              class="svg-path"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                        @case ('/facility-management/customers') {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            >
                            <g clip-path="url(#clip0_7213_9421)">
                              <path
                                d="M9.99154 1.66602C5.39154 1.66602 1.6582 5.39935 1.6582 9.99935C1.6582 14.5993 5.39154 18.3327 9.99154 18.3327C14.5915 18.3327 18.3249 14.5993 18.3249 9.99935C18.3249 5.39935 14.5915 1.66602 9.99154 1.66602ZM12.9999 6.94935C13.8915 6.94935 14.6082 7.66602 14.6082 8.55768C14.6082 9.44935 13.8915 10.166 12.9999 10.166C12.1082 10.166 11.3915 9.44935 11.3915 8.55768C11.3832 7.66602 12.1082 6.94935 12.9999 6.94935ZM7.99987 5.63268C9.0832 5.63268 9.96654 6.51602 9.96654 7.59935C9.96654 8.68268 9.0832 9.56602 7.99987 9.56602C6.91654 9.56602 6.0332 8.68268 6.0332 7.59935C6.0332 6.50768 6.9082 5.63268 7.99987 5.63268ZM7.99987 13.241V16.366C5.99987 15.741 4.41654 14.1993 3.71654 12.2327C4.59154 11.2993 6.77487 10.8243 7.99987 10.8243C8.44154 10.8243 8.99987 10.891 9.5832 11.0077C8.21654 11.7327 7.99987 12.691 7.99987 13.241ZM9.99154 16.666C9.76654 16.666 9.54987 16.6577 9.3332 16.6327V13.241C9.3332 12.0577 11.7832 11.466 12.9999 11.466C13.8915 11.466 15.4332 11.791 16.1999 12.4243C15.2249 14.8993 12.8165 16.666 9.99154 16.666Z"
                                class="svg-path"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_7213_9421">
                                  <rect width="20" height="20" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          }
                          @case ('/maleman-kit/batch') {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              >
                              <g clip-path="url(#clip0_7213_9416)">
                                <path
                                  d="M18.9167 15.8328L11.3334 8.24948C12.0834 6.33281 11.6667 4.08281 10.0834 2.49948C8.4167 0.832814 5.9167 0.499481 3.9167 1.41615L7.50003 4.99948L5.00003 7.49948L1.33336 3.91615C0.333364 5.91615 0.750031 8.41615 2.4167 10.0828C4.00003 11.6661 6.25003 12.0828 8.1667 11.3328L15.75 18.9161C16.0834 19.2495 16.5834 19.2495 16.9167 18.9161L18.8334 16.9995C19.25 16.6661 19.25 16.0828 18.9167 15.8328Z"
                                  class="svg-path"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_7213_9416">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            }
                            <!-- Case 2: default / other paths -->
                            @default {
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                >
                                <path [attr.d]="sidebarItem.svgd" class="svg-path"></path>
                              </svg>
                            }
                          }
                        </div>
                        <span class="hide-menu">
                          <p
                            [attr.automation-id]="'sidebar-i-' + sidebarItem.automationId"
                            >
                            {{ sidebarItem.title | translate }}
                          </p>
                        </span>
                        @if (sidebarItem.badge !== '') {
                          <span
                            [ngClass]="[sidebarItem.badgeClass]"
                            >{{ sidebarItem.badge }}</span
                            >
                          }
                        </a>
                      }
                      <!-- First level menu -->
                      @if (sidebarItem.submenu.length > 0) {
                        <ul
                          automation-id="sidebar-ul-14"
                          class="ml-menu"
                          >
                          @for (sidebarSubItem1 of sidebarItem.submenu; track sidebarSubItem1) {
                            <li
                              automation-id="sidebar-li-15"
                [routerLinkActive]="
                  sidebarSubItem1.submenu.length > 0 ? '' : 'active'
                "
                              >
                              <a
                                automation-id="sidebar-a-16"
                  [routerLink]="
                    sidebarSubItem1.submenu.length > 0
                      ? null
                      : [sidebarSubItem1.path]
                  "
                  (click)="
                    callToggleMenu($event, sidebarSubItem1.submenu.length)
                  "
                                [ngClass]="[sidebarSubItem1.class]"
                                >
                                {{ sidebarSubItem1.title | translate }}
                              </a>
                              <!-- Second level menu -->
                              @if (sidebarSubItem1.submenu.length > 0) {
                                <ul
                                  automation-id="sidebar-ul-17"
                                  class="ml-menu-2"
                                  >
                                  @for (sidebarSubItem2 of sidebarSubItem1.submenu; track sidebarSubItem2) {
                                    <li
                                      automation-id="sidebar-li-18"
                    [routerLinkActive]="
                      sidebarSubItem2.submenu.length > 0 ? '' : 'active'
                    "
                                      >
                                      <a
                                        automation-id="sidebar-a-19"
                      [routerLink]="
                        sidebarSubItem2.submenu.length > 0
                          ? null
                          : [sidebarSubItem2.path]
                      "
                      (click)="
                        callToggleMenu($event, sidebarSubItem2.submenu.length)
                      "
                                        [ngClass]="[sidebarSubItem2.class]"
                                        >
                                        {{ sidebarSubItem2.title | translate }}
                                      </a>
                                      <!-- Third level menu -->
                                      @if (sidebarSubItem2.submenu.length > 0) {
                                        <ul
                                          automation-id="sidebar-ul-20"
                                          class="ml-menu-3"
                                          >
                                          @for (sidebarSubItem3 of sidebarSubItem2.submenu; track sidebarSubItem3) {
                                            <li
                                              automation-id="sidebar-li-21"
                        [routerLinkActive]="
                          sidebarSubItem3.submenu.length > 0 ? '' : 'active'
                        "
                                              >
                                              <a
                                                automation-id="sidebar-a-22"
                          [routerLink]="
                            sidebarSubItem3.submenu.length > 0
                              ? null
                              : [sidebarSubItem3.path]
                          "
                          (click)="
                            callToggleMenu(
                              $event,
                              sidebarSubItem3.submenu.length
                            )
                          "
                                                [ngClass]="[sidebarSubItem3.class]"
                                                >
                                                {{ sidebarSubItem3.title | translate }}
                                              </a>
                                            </li>
                                          }
                                        </ul>
                                      }
                                    </li>
                                  }
                                </ul>
                              }
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                  <li automation-id="sidebar-li-23" class="logOutPos">
                    <a
                      automation-id="sidebar-a-logout"
                      (click)="logout()"
                      class="menu-top" [ngClass]="
                (_glob.submitOrderProcess$ | async)
                  ? 'no-pointers'
                  : 'all-pointers'
              "
                      >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        style="margin-top: 1px"
                        >
                        <g clip-path="url(#clip0_6570_23645)">
                          <path
                            d="M10.8333 2.5H9.16667V10.8333H10.8333V2.5ZM14.8583 4.30833L13.675 5.49167C14.9917 6.55 15.8333 8.175 15.8333 10C15.8333 13.225 13.225 15.8333 10 15.8333C6.775 15.8333 4.16667 13.225 4.16667 10C4.16667 8.175 5.00833 6.55 6.31667 5.48333L5.14167 4.30833C3.525 5.68333 2.5 7.71667 2.5 10C2.5 14.1417 5.85833 17.5 10 17.5C14.1417 17.5 17.5 14.1417 17.5 10C17.5 7.71667 16.475 5.68333 14.8583 4.30833Z"
                            fill="#24282C"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6570_23645">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span class="hide-menu"
                          ><p automation-id="sidebar-p-logout">Logout</p>
                        </span>
                      </a>
                    </li>
                  </ul>
                  <div class="version sidebar-user-panel">
                    <p automation-id="sidebar-p-27">Version {{ appVersion }}</p>
                  </div>
                </ng-scrollbar>
              </div>
              <!-- #Menu -->
            </aside>
            <!-- #END# Left Sidebar -->
          </div>
